import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { forwardRef, FunctionComponent, useState } from 'react';

import useIsMobile from '../../../hooks/use-is-mobile';
import FeaturedLink from '../../ui/links/featured';

const Observation: FunctionComponent<{
  observations: TProductDetail['observations'];
  observations_original: TProductDetail['observations_original'];
  observations_original_lang: TProductDetail['observations_original_lang'];
  observations_internal: TProductDetail['observations_internal'];
  ref?: any;
  key?: string;
}> = forwardRef(
  (
    {
      observations,
      observations_original,
      observations_original_lang,
      observations_internal,
      key,
    },
    ref
  ) => {
    const [showOriginalObservation, setShowOriginalObservation] =
      useState<boolean>(!observations);
    const { t } = useTranslation();
    const isMobile = useIsMobile();

    const observations_original_lang_name = observations_original
      ? t(`product:original_language.${observations_original_lang}`)
      : '';

    return (
      <div key={key} className="bg-brand-10 max-md:px-4 lg:px-4 py-8 lg:py-6">
        <div className="max-lg:container max-lg:mx-auto">
          <h3
            id="pp_observations"
            ref={ref}
            className={cx(
              'font-bold',
              'text-lg',
              'text-neutral-80 scroll-mt-[316px] lg:scroll-mt-[190px]'
            )}
          >
            {t('product:observations')}
          </h3>
          <p className={cx('text-sm', 'break-all')}>{observations}</p>
          {observations && observations_original && (
            <p className="text-sm text-neutral-80 py-2">
              {t('product:translated_observation', {
                original_languge: observations_original_lang_name,
              })}
            </p>
          )}
          {!showOriginalObservation && observations_original && (
            <FeaturedLink
              variant="default"
              as="a"
              className="flex flex-row gap-6 items-center justify-center text-sm lg:justify-between w-fit font-bold text-neutral-80 hover:text-blue-100"
              onClick={() => setShowOriginalObservation(true)}
            >
              <>{t('product:translated_observation_link')}</>
            </FeaturedLink>
          )}
          {showOriginalObservation && (
            <div
              className={cx(
                'flex ',
                observations &&
                  observations_original &&
                  'border-l-neutral-80 border-l-4 pl-4'
              )}
            >
              <p
                className={cx('text-sm', 'break-all')}
                dangerouslySetInnerHTML={{
                  __html: observations_original,
                }}
              />
            </div>
          )}
          {observations_internal && (
            <p
              className={cx('text-sm')}
              dangerouslySetInnerHTML={{
                __html: observations_internal,
              }}
            />
          )}

          {!observations &&
            !observations_original &&
            !observations_internal && (
              <p className={cx('text-sm')}>{t('product:no_observations')}</p>
            )}
        </div>
      </div>
    );
  }
);

export default Observation;
